/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './authManageFeedDeclarations.defs.js'
export * as $defs from './authManageFeedDeclarations.defs.js'
